export default __webpack_public_path__ + "static/media/triage-shape.05b59740.svg";